import React from 'react'

import ButtonSignOut from 'components/ButtonSignOut'
import Link from 'components/Link'
import withAuth from 'components/withAuth'
import paths from 'constants/paths'

export function Nav({ loading, user }: props) {
  if (loading) return null

  return (
    <nav>
      <ul className="uk-navbar-nav">
        {user ? (
          <React.Fragment>
            <li>
              <Link to={paths.REPORTS} nav>Reports</Link>
            </li>
            <li>
              <Link to={paths.ACCOUNT} nav>Account</Link>
            </li>
            <li>
              <ButtonSignOut />
            </li>
          </React.Fragment>
          ) : (
            <React.Fragment>
              <li>
                <Link to={paths.SIGN_UP} nav>Sign up</Link>
              </li>
              {/*
              <li>
                <Link to={paths.SIGN_IN} nav>Sign in</Link>
              </li>
              */}
            </React.Fragment>
          )
        }
      </ul>
    </nav>
  )
}

export default withAuth(Nav)



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.js